import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import '@/helper/headers';
import VueSignaturePad from 'vue-signature-pad'

Vue.config.productionTip = false
Vue.use(VueSignaturePad)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
